import { getIsOwnerApp } from '../../app/app-state.js';
import { showView } from '../../app/navigation.js';
import {
  setOwnerChatActiveConversationUserId,
  setOwnerChatSelectedDisplayName,
  setOwnerChatMode,
  setOwnerChatActiveOrderId,
  setOwnerChatActiveOrderTitle,
  setOwnerChatActiveCustomerUserId,
  resetOwnerChatOrderContext,
  setOwnerChatListTab
} from '../owner-chat/ui-state.js';
import { getOwnerChatViewerId } from '../owner-chat/dom.js';
import { buildOrderChatThreadId, orderChatShortId } from '../../lib/order-chat-thread.js';

export interface OpenOrderChatParams {
  orderId: string;
  orderTitle: string;
  userId?: string;
  username?: string;
  backTo?: string;
}

export function openOrderChat(params: OpenOrderChatParams): void {
  const backTo = params.backTo || 'view-order-detail';
  const backBtn = document.querySelector<HTMLElement>('#view-consult .back-btn');
  if (backBtn) backBtn.dataset.backTo = backTo;

  const shortId = orderChatShortId(params.orderId);
  const orderLabel = 'Заказ #' + shortId;

  setOwnerChatMode('order');
  setOwnerChatActiveOrderId(params.orderId);
  setOwnerChatActiveOrderTitle(params.orderTitle || '');

  if (getIsOwnerApp()) {
    if (!params.userId) return;
    setOwnerChatActiveCustomerUserId(params.userId);
    setOwnerChatActiveConversationUserId(buildOrderChatThreadId(params.userId, params.orderId));
    const who = params.username ? '@' + String(params.username).replace(/^@/, '') : 'Клиент';
    setOwnerChatSelectedDisplayName(orderLabel + ' · ' + who);
  } else {
    const viewerId = getOwnerChatViewerId();
    if (!viewerId) return;
    setOwnerChatActiveCustomerUserId(viewerId);
    setOwnerChatActiveConversationUserId(buildOrderChatThreadId(viewerId, params.orderId));
    setOwnerChatSelectedDisplayName(orderLabel);
  }

  showView('view-consult', 'right');
}

export function openConsultChat(backTo?: string): void {
  setOwnerChatMode('consult');
  resetOwnerChatOrderContext();

  if (getIsOwnerApp()) {
    setOwnerChatListTab('consult');
    setOwnerChatActiveConversationUserId(null);
    setOwnerChatSelectedDisplayName('');
    showView('view-owner-chat-list', 'right');
    return;
  }

  const backBtn = document.querySelector<HTMLElement>('#view-consult .back-btn');
  if (backBtn) backBtn.dataset.backTo = backTo || 'view-main';

  setOwnerChatActiveConversationUserId(getOwnerChatViewerId());
  setOwnerChatSelectedDisplayName('Консультация');
  showView('view-consult', 'right');
}
